import * as React from 'react'

import { Link } from 'gatsby'

const Frameworks = () => {
  return (
    <div>
      <p>
        <Link>ExpressJs</Link>
      </p>
      <p>
        <Link to="Reactjs">Reactjs</Link>
      </p>
    </div>
  )
}

export default Frameworks
